import { css } from '@emotion/css';
import * as React from 'react';

import { Color } from '../css/theme';

interface Props {
  error?: string;
}

const errorContainer = css({
  color: Color.Error,
});

const FormInputError = ({ error }: Props) => {
  return !!error && <div className={errorContainer}>{error}</div>;
};

export default FormInputError;
